import ContactHero from "../components/Contact/ContactHero";
import FormSection from "../components/Contact/FormSection";
import OfficeLocations from "../components/Contact/OfficeLocations";
import FadeInSection from "../components/FadeInSection";
import Footer from "../components/Footer";
import TechNavbar from "../components/TechNavbar";

function Contact() {
  return (
    <div className="min-h-screen bg-white font-sans">
      {/* <Header /> */}

      <TechNavbar />

      {/* CONTACTS PAGE HERO SECTION */}
      <FadeInSection>
        <ContactHero />
      </FadeInSection>

      {/* OFFICE LOCATIONS SECTION */}
      <FadeInSection>
        <OfficeLocations />
      </FadeInSection>

      {/* CONTACT FORM SECTION */}
      <FadeInSection>
        <FormSection />
      </FadeInSection>

      <Footer />
    </div>
  );
}

export default Contact;
